import Vue from 'vue'
import Router from 'vue-router'
import admin from '@/view/admin.vue'

Vue.use(Router)


export const routes = [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login.vue'),
      meta: {title: '登录',keepAlive: false},
    },
    {
      path: '',
      component: admin,
      redirect: '/home',
      activPath:'home',
      noChildren:false,
      meta: {title: '首页',keepAlive: false},
      children: [{
        path: 'home',
        name: 'home',
        component: () => import('@/view/home/index.vue'),
      },],
    },
    // {
    //   path: '/home',
    //   component: admin,
    //   redirect: '/home/homeCP',
    //   activPath:'home',
    //   noChildren:false,
    //   meta: {title: '首页',icon:require('../assets/a.png'),de_icon:require('../assets/a1.png')},
    //   children: [{
    //     path: 'homeCP',
    //     name: 'homeCP',
    //     component: () => import('@/view/home/homeCP/index.vue'),
    //   },],
    // },
    {
      path: '/chart',
      name: 'chart',
      component: () => import('@/view/chart/chartCP/homeChart.vue'),
      meta: {title: '销售数据可视化',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/tradeChart',
      name: 'tradeChart',
      component: () => import('@/view/tradeChart/tradeChartCp/index.vue'),
      meta: {title: '今年接单和出货数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart',
      name: 'businessChart',
      component: () => import('@/view/businessChart/businessChartCP/index.vue'),
      meta: {title: '菲尔事业部全国数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/salesDetail',
      name: 'salesDetail',
      component: () => import('@/view/businessChart/businessChartCP/salesDetail.vue'),
      meta: {title: '销售业绩排名',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/productDetai100',
      name: 'productDetai100',
      component: () => import('@/view/businessChart/businessChartCP/productDetai100.vue'),
      meta: {title: '菲尔事业部产品数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/productDetai',
      name: 'productDetai',
      component: () => import('@/view/businessChart/businessChartCP/productDetai.vue'),
      meta: {title: '菲尔事业部产品数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/returnDetai',
      name: 'returnDetai',
      component: () => import('@/view/businessChart/businessChartCP/returnDetai.vue'),
      meta: {title: '菲尔事业部退货数据明细',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/takeGoodsDetail',
      name: 'takeGoodsDetail',
      component: () => import('@/view/businessChart/businessChartCP/takeGoodsDetail.vue'),
      meta: {title: '菲尔事业部客户拿货明细',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/regionPage',
      name: 'regionPage',
      component: () => import('@/view/businessChart/businessChartCP/regionPage.vue'),
      meta: {title: '菲尔事业部区域数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/businessChart/SCMpage',
      name: 'SCMpage',
      component: () => import('@/view/businessChart/businessChartCP/SCMpage.vue'),
      meta: {title: '供应链数据看板',keepAlive: false},
      ishidden:true,
    },
    {
      path: '/productChart',
      name: 'productChart',
      component: () => import('@/view/productChart/productChartCP/index.vue'),
      meta: {title: '产品部数据看板',keepAlive: false},
      ishidden:true,
    },
    
    {
    	path: '/procure',
    	name: 'procure',
      activPath:'procure',
      component: admin,
      redirect: '/procure/procureCP',
      noChildren:true,
      meta: {title: '需求'},
      children:[
        {
          path: '/procure/procureCP',
          name: 'procureCP',
          component: () => import('@/view/procure/procureCP/procurementList.vue'),
          meta: {title: '采购需求列表',sideBar:false,keepAlive: false},
        },
        {
          path: '/procureCP/procurementDetail',
          name: 'procurementDetail',
          component: () => import('@/view/procure/procureCP/procurementDetail.vue'),
          meta: {title: '采购需求详情',sideBar:false,keepAlive: false},
          hidden:true
        },
        {
          path: '/procureCP/procurementAlter',
          name: 'procurementAlter',
          component: () => import('@/view/procure/procureCP/procurementAlter.vue'),
          meta: {title: '采购需求变更',sideBar:false,keepAlive: false},
          hidden:true
        },
        {
          path: '/procureCP/needsAlterRecord',
          name: 'needsAlterRecord',
          component: () => import('@/view/procure/procureCP/needsAlterRecord.vue'),
          meta: {title: '采购需求变更记录',sideBar:false,keepAlive: false},
        },
        {
          path: '/procureCP/procureOrderAlter',
          name: 'procureOrderAlter',
          component: () => import('@/view/procure/procureCP/procureOrderAlter.vue'),
          meta: {title: '采购订单变更记录',sideBar:false,keepAlive: false},
        },
        {
          path: '/procureCP/procureHistory',
          name: 'procureHistory',
          component: () => import('@/view/procure/procureCP/procureHistory.vue'),
          meta: {title: '采购历史',sideBar:false,keepAlive: false},
        },
        {
          path: '/procureCP/procureHistoryView',
          name: 'procureHistoryView',
          component: () => import('@/view/procure/procureCP/procureHistoryView.vue'),
          meta: {title: '采购历史详情',sideBar:false,keepAlive: false},
          hidden:true
        }
      ]
    },

    {
    	path: '/customer',
    	name: 'customer',
      activPath:'customer',
      component: admin,
      redirect: '/customer/customerCP',
      noChildren:false,
      meta: {title: '客户'},
      children:[
        {
          path: 'customerCP',
          name: 'customerCP',
          component: () => import('@/view/customer/customerCP/index.vue'),
          meta: {title: '我的客户',sideBar:true,keepAlive: true},
        },
        // {
        //   path: 'highSeas',
        //   name: 'highSeas',
        //   component: () => import('@/view/customer/customerCP/highSeas.vue'),
        //   meta: {title: '客户公海'},
        // },
        {
          path: 'customerDetail',
          name: 'customerDetail',
          component: () => import('@/view/customer/customerCP/customerDetail.vue'),
          meta: {title: '客户详细信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'customerInput',
          name: 'customerInput',
          component: () => import('@/view/customer/customerCP/customerInput.vue'),
          meta: {title: '客户信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_addressBook',
          name: 'c_addressBook',
          component: () => import('@/view/customer/customerCP/c_addressBook.vue'),
          meta: {title: '通讯录',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_followRecord',
          name: 'c_followRecord',
          component: () => import('@/view/customer/customerCP/c_followRecord.vue'),
          meta: {title: '跟进记录',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_memorandum',
          name: 'c_memorandum',
          component: () => import('@/view/customer/customerCP/c_memorandum.vue'),
          meta: {title: '备忘录',keepAlive: false},
          hidden:true
        },
        {
          path: 'baseInformation',
          name: 'baseInformation',
          component: () => import('@/view/customer/customerCP/baseInformation.vue'),
          meta: {title: '客户基本信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'companyPersonnel',
          name: 'companyPersonnel',
          component: () => import('@/view/customer/customerCP/companyPersonnel.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'account',
          name: 'account',
          component: () => import('@/view/customer/customerCP/account.vue'),
          meta: {title: '账号管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'points',
          name: 'points',
          component: () => import('@/view/customer/customerCP/points.vue'),
          meta: {title: '积分管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAccount',
          name: 'bankAccount',
          component: () => import('@/view/customer/customerCP/bankAccount.vue'),
          meta: {title: '银行账户',keepAlive: false},
          hidden:true
        },
        {
          path: 'shoppingCart',
          name: 'shoppingCart',
          component: () => import('@/view/customer/customerCP/shoppingCart.vue'),
          meta: {title: '购物车',keepAlive: false},
          hidden:true
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: () => import('@/view/customer/customerCP/favorites.vue'),
          meta: {title: '收藏夹',keepAlive: false},
          hidden:true
        },
        {
          path: 'consumptionAnalysis',
          name: 'consumptionAnalysis',
          component: () => import('@/view/customer/customerCP/consumptionAnalysis.vue'),
          meta: {title: '消费分析统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'behaviorAnalysis',
          name: 'behaviorAnalysis',
          component: () => import('@/view/customer/customerCP/behaviorAnalysis.vue'),
          meta: {title: '行为分析统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'followUpRecord',
          name: 'followUpRecord',
          component: () => import('@/view/customer/customerCP/followUpRecord.vue'),
          meta: {title: '跟进记录',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelDetail',
          name: 'personnelDetail',
          component: () => import('@/view/customer/customerCP/personnelDetail.vue'),
          meta: {title: '公司人员信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelAddEdit',
          name: 'personnelAddEdit',
          component: () => import('@/view/customer/customerCP/personnelAddEdit.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'accountAddEdit',
          name: 'accountAddEdit',
          component: () => import('@/view/customer/customerCP/accountAddEdit.vue'),
          meta: {title: '公司账号',keepAlive: false},
          hidden:true
        },
        {
          path: 'pointsEdit',
          name: 'pointsEdit',
          component: () => import('@/view/customer/customerCP/pointsEdit.vue'),
          meta: {title: '积分订单编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAddEdit',
          name: 'bankAddEdit',
          component: () => import('@/view/customer/customerCP/bankAddEdit.vue'),
          meta: {title: '银行账号编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'orderStatistics',
          name: 'orderStatistics',
          component: () => import('@/view/customer/customerCP/orderStatistics.vue'),
          meta: {title: '订单统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'returnStatistics',
          name: 'returnStatistics',
          component: () => import('@/view/customer/customerCP/returnStatistics.vue'),
          meta: {title: '退货统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'relatedBusiness',
          name: 'relatedBusiness',
          component: () => import('@/view/customer/customerCP/relatedBusiness.vue'),
          meta: {title: '业务关联客户管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'rebate',
          name: 'rebate',
          component: () => import('@/view/customer/customerCP/rebate.vue'),
          meta: {title: '扶商返利',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/product',
    	name: 'product',
      activPath:'product',
      component: admin,
      redirect: '/product/productCP',
      noChildren:false,
      meta: {title: '产品'},
      children:[
        {
          path: 'productCP',
          name: 'productCP',
          component: () => import('@/view/product/productCP/index.vue'),
          meta: {title: '菲尔产品',sideBar:true,keepAlive: true},
        },
        // {
        //   path: 'productHighSeas',
        //   name: 'productHighSeas',
        //   component: () => import('@/view/product/productCP/productHighSeas.vue'),
        //   meta: {title: '产品公海'},
        // },
        {
          path: 'productDetail',
          name: 'productDetail',
          component: () => import('@/view/product/productCP/productDetail.vue'),
          meta: {title: '产品详情',keepAlive: false},
          hidden:true
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/view/product/productCP/feedback.vue'),
          meta: {title: '相关问题',keepAlive: false},
          hidden:true
        },
        {
          path: 'VINDetails',
          name: 'VINDetails',
          component: () => import('@/view/product/productCP/VINDetails.vue'),
          meta: {title: 'VIN结果',keepAlive: false},
          hidden:true
        },
        {
          path: 'salesHistory',
          name: 'salesHistory',
          component: () => import('@/view/product/productCP/salesHistory.vue'),
          meta: {title: '销售历史',keepAlive: false},
          hidden:true
        },
        {
          path: 'productDetailEdit',
          name: 'productDetailEdit',
          component: () => import('@/view/product/productCP/productDetailEdit.vue'),
          meta: {title: '产品信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPic',
          name: 'productPic',
          component: () => import('@/view/product/productCP/productPic.vue'),
          meta: {title: '图片',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPrice',
          name: 'productPrice',
          component: () => import('@/view/product/productCP/productPrice.vue'),
          meta: {title: '价格',keepAlive: false},
          hidden:true
        },
        {
          path: 'productModel',
          name: 'productModel',
          component: () => import('@/view/product/productCP/productModel.vue'),
          meta: {title: '适用车型',keepAlive: false},
          hidden:true
        },
        {
          path: 'productLanguage',
          name: 'productLanguage',
          component: () => import('@/view/product/productCP/productLanguage.vue'),
          meta: {title: '其他语言',keepAlive: false},
          hidden:true
        },
        {
          path: 'productContrast',
          name: 'productContrast',
          component: () => import('@/view/product/productCP/productContrast.vue'),
          meta: {title: '对照号',keepAlive: false},
          hidden:true
        },
        {
          path: 'productShop',
          name: 'productShop',
          component: () => import('@/view/product/productCP/productShop.vue'),
          meta: {title: '电商内容',keepAlive: false},
          hidden:true
        },
        {
          path: 'productRelation',
          name: 'productRelation',
          component: () => import('@/view/product/productCP/productRelation.vue'),
          meta: {title: '关联设置',keepAlive: false},
          hidden:true
        },
        {
          path: 'productknowledge',
          name: 'productknowledge',
          component: () => import('@/view/product/productCP/productknowledge.vue'),
          meta: {title: '知识库',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPrinting',
          name: 'productPrinting',
          component: () => import('@/view/product/productCP/productPrinting.vue'),
          meta: {title: '标签打印',keepAlive: false},
          hidden:true
        },
        {
          path: 'productStore',
          name: 'productStore',
          component: () => import('@/view/product/productCP/productStore.vue'),
          meta: {title: '门店价格维护',keepAlive: false},
          hidden:true
        },
        {
          path: 'productCustomerStock',
          name: 'productCustomerStock',
          component: () => import('@/view/product/productCP/productCustomerStock.vue'),
          meta: {title: '客户库存',keepAlive: false},
          hidden:true
        },
        {
          path: 'productOnHandStock',
          name: 'productOnHandStock',
          component: () => import('@/view/product/productCP/productOnHandStock.vue'),
          meta: {title: '现有库存',keepAlive: false},
          hidden:true
        },
        {
          path: 'productTest',
          name: 'productTest',
          component: () => import('@/view/product/productCP/productTest.vue'),
          meta: {title: '检验项目',keepAlive: false},
          hidden:true
        },
        {
          path: 'productDrawing',
          name: 'productDrawing',
          component: () => import('@/view/product/productCP/productDrawing.vue'),
          meta: {title: '检测图纸',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/select',
    	name: 'select',
      activPath:'select',
      component: admin,
      redirect: '/select/cart',
      noChildren:false,
      meta: {title: '购物车'},
      children:[
        {
          path: 'cart',
          name: 'cart',
          component: () => import('@/view/select/cart/index.vue'),
          meta: {title: '购物车',sideBar:true,keepAlive: true},
        },
      ],
    },
    {
    	path: '/bills',
    	name: 'bills',
      activPath:'bills',
      component: admin,
      noChildren:false,
      redirect: '/bills/billsCP',
      meta: {title: '订单'},
      children:[
        {
          path: 'billsCP',
          name: 'billsCP',
          component: () => import('@/view/bills/billsCP/order.vue'),
          meta: {title: '订单',sideBar:true,keepAlive: true},
        },
        {
          path: 'generateOrderDetail',
          name: 'generateOrderDetail',
          component: () => import('@/view/bills/billsCP/generateOrderDetail.vue'),
          meta: {title: '订单详情',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/pack',
    	name: 'pack',
      activPath:'pack',
      component: admin,
      redirect: '/pack/packCP',
      noChildren:false,
      meta: {title: '打包(发货)'},
      children:[
        {
          path: 'packCP',
          name: 'packCP',
          component: () => import('@/view/pack/packCP/pack.vue'),
          meta: {title: '打包(发货)',sideBar:true,keepAlive: false},
        },
        {
          path: 'g_AddEditPackOrder',
          name: 'g_AddEditPackOrder',
          component: () => import('@/view/pack/packCP/g_AddEditPackOrder.vue'),
          meta: {title: '打包(发货)详情',keepAlive: false},
          hidden:true
        },
        {
          path: 'generatePackOrder',
          name: 'generatePackOrder',
          component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
          meta: {title: '其他打包(发货)',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/SHistory',
    	name: 'SHistory',
      activPath:'SHistory',
      component: admin,
      redirect: '/SHistory/SHistoryCP',
      noChildren:false,
      meta: {title: '销售历史'},
      children:[
        {
          path: 'SHistoryCP',
          name: 'SHistoryCP',
          component: () => import('@/view/SHistory/SHistoryCP/SHistory.vue'),
          meta: {title: '销售历史',sideBar:true,keepAlive: false},
        },
      ],
    },
    {
    	path: '/other',
    	name: 'other',
      activPath:'other',
      component: admin,
      redirect: '/other/purchaseResponse/purchaseResponseCP',
      noChildren:true,
      meta: {title: '其他'},
      children:[
        {
          path: '/purchaseResponse/purchaseResponseCP',
          name: 'purchaseResponseCP',
          component: () => import('@/view/other/purchaseResponse/purchaseResponseCP/index.vue'),
          meta: {title: '采购',sideBar:true,keepAlive: false},
        },
        {
          path: '/ztStockManage/ztStockManageCP',
          name: 'ztStockManageCP',
          component: () => import('@/view/other/ztStockManage/ztStockManageCP/index.vue'),
          meta: {title: '在途库存管理',sideBar:true,keepAlive: false},
        },
        {
          path: '/statistics/statisticsCP',
          name: 'statisticsCP',
          component: () => import('@/view/other/statistics/statisticsCP/index.vue'),
          meta: {title: '统计',keepAlive: false},
        },
        {
          path: '/quotedPrice/quotedPriceCP',
          name: 'quotedPriceCP',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/index.vue'),
          meta: {title: '报价',sideBar:true,keepAlive: true},
        },
        {
          path: '/quotedPrice/generateQuotedPriceOrder',
          name: 'generateQuotedPriceOrder',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/generateQuotedPriceOrder.vue'),
          meta: {title: '报价单详情',keepAlive: false},
          hidden:true
        },
        {
          path: '/quotedPrice/quotedHistory',
          name: 'quotedHistory',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/quotedHistory.vue'),
          meta: {title: '报价历史',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/credit',
          name: 'credit',
          component: () => import('@/view/other/otherBills/billsCP/credit.vue'),
          meta: {title: '借贷项',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/packing',
          name: 'packing',
          component: () => import('@/view/other/otherBills/billsCP/packing.vue'),
          meta: {title: '装箱单',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/gift',
          name: 'gift',
          component: () => import('@/view/other/otherBills/billsCP/gift.vue'),
          meta: {title: '礼品单',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/returnGoods',
          name: 'returnGoods',
          component: () => import('@/view/other/otherBills/billsCP/returnGoods.vue'),
          meta: {title: '退货单',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/noReturnGoods',
          name: 'noReturnGoods',
          component: () => import('@/view/other/otherBills/billsCP/noReturnGoods.vue'),
          meta: {title: '无实物退货',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/otherBills/materialObject',
          name: 'materialObject',
          component: () => import('@/view/other/otherBills/billsCP/materialObject.vue'),
          meta: {title: '生成有实物退货单',keepAlive: false},
          hidden:true
        },
        {
          path: '/otherBills/noMaterialObject',
          name: 'noMaterialObject',
          component: () => import('@/view/other/otherBills/billsCP/noMaterialObject.vue'),
          meta: {title: '生成无实物退货单',keepAlive: false},
          hidden:true
        },
        {
          path: '/otherBills/generateGiftOrder',
          name: 'generateGiftOrder',
          component: () => import('@/view/other/otherBills/billsCP/generateGiftOrder.vue'),
          meta: {title: '礼品单详情',keepAlive: false},
          hidden:true
        },
        {
          path: '/trackingPlan/trackingPlanCP',
          name: 'trackingPlanCP',
          component: () => import('@/view/other/trackingPlan/trackingPlanCP/index.vue'),
          meta: {title: '计划跟踪',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/sprinter/sprinterCP',
          name: 'pdDimension',
          component: () => import('@/view/other/sprinter/sprinterCP/pdDimension.vue'),
          meta: {title: '数据分析',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/sprinter/marketDimension',
          name: 'marketDimension',
          component: () => import('@/view/other/sprinter/sprinterCP/marketDimension.vue'),
          meta: {title: '市场维度',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/sprinter/customerDimension',
          name: 'customerDimension',
          component: () => import('@/view/other/sprinter/sprinterCP/customerDimension.vue'),
          meta: {title: '客户维度',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/salesDemand/salesDemandCP',
          name: 'salesDemand',
          component: () => import('@/view/other/salesDemand/salesDemandCP/index.vue'),
          meta: {title: '销售需求',sideBar:true,keepAlive: true},
        },
        // {
        //   path: '/contract/contractCP',
        //   name: 'contract',
        //   component: () => import('@/view/other/contract/contractCP/index.vue'),
        //   meta: {title: '合同管理',sideBar:true,keepAlive: true},
        // },
        // {
        //   path: '/contract/contractEdit',
        //   name: 'contractEdit',
        //   component: () => import('@/view/other/contract/contractCP/contractEdit.vue'),
        //   meta: {title: '合同页面',keepAlive: true},
        //   hidden:true
        // },
        // {
        //   path: '/contract/contractPreview',
        //   name: 'contractPreview',
        //   component: () => import('@/view/other/contract/contractCP/contractPreview.vue'),
        //   meta: {title: '合同预览',keepAlive: true},
        //   hidden:true
        // },
      ],
    },
  ]


export const routes2 = [
    {
      path: '/procure',
      name: 'procure',
      activPath:'procure',
      component: admin,
      redirect: '/procure/procureCP',
      noChildren:true,
      meta: {title: '需求'},
      children:[
        {
          path: '/procure/procureCP',
          name: 'procureCP',
          component: () => import('@/view/procure/procureCP/procurementList.vue'),
          meta: {title: '采购需求列表',sideBar:true,keepAlive: false},
        },
        {
          path: '/procureCP/procurementDetail',
          name: 'procurementDetail',
          component: () => import('@/view/procure/procureCP/procurementDetail.vue'),
          meta: {title: '采购需求详情',sideBar:false,keepAlive: false},
          hidden:true
        },
        {
          path: '/procureCP/procurementAlter',
          name: 'procurementAlter',
          component: () => import('@/view/procure/procureCP/procurementAlter.vue'),
          meta: {title: '采购需求变更',sideBar:false,keepAlive: false},
          hidden:true
        },
        {
          path: '/procureCP/needsAlterRecord',
          name: 'needsAlterRecord',
          component: () => import('@/view/procure/procureCP/needsAlterRecord.vue'),
          meta: {title: '采购需求变更记录',sideBar:true,keepAlive: false},
        },
        {
          path: '/procureCP/procureOrderAlter',
          name: 'procureOrderAlter',
          component: () => import('@/view/procure/procureCP/procureOrderAlter.vue'),
          meta: {title: '采购订单变更记录',sideBar:true,keepAlive: false},
        },
        {
          path: '/procureCP/procureHistory',
          name: 'procureHistory',
          component: () => import('@/view/procure/procureCP/procureHistory.vue'),
          meta: {title: '采购历史',sideBar:true,keepAlive: false},
        },
        {
          path: '/procureCP/procureHistoryView',
          name: 'procureHistoryView',
          component: () => import('@/view/procure/procureCP/procureHistoryView.vue'),
          meta: {title: '采购历史详情',sideBar:false,keepAlive: false},
          hidden:true
        }
      ]
    },
    {
    	path: '/customer',
    	name: 'customer',
      activPath:'customer',
      component: admin,
      redirect: '/customer/customerCP',
      noChildren:false,
      meta: {title: '客户'},
      children:[
        {
          path: 'customerCP',
          name: 'customerCP',
          component: () => import('@/view/customer/customerCP/index.vue'),
          meta: {title: '我的客户',sideBar:true,keepAlive: true},
        },
        // {
        //   path: 'highSeas',
        //   name: 'highSeas',
        //   component: () => import('@/view/customer/customerCP/highSeas.vue'),
        //   meta: {title: '客户公海'},
        // },
        {
          path: 'customerDetail',
          name: 'customerDetail',
          component: () => import('@/view/customer/customerCP/customerDetail.vue'),
          meta: {title: '客户详细信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'customerInput',
          name: 'customerInput',
          component: () => import('@/view/customer/customerCP/customerInput.vue'),
          meta: {title: '客户信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_addressBook',
          name: 'c_addressBook',
          component: () => import('@/view/customer/customerCP/c_addressBook.vue'),
          meta: {title: '通讯录',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_followRecord',
          name: 'c_followRecord',
          component: () => import('@/view/customer/customerCP/c_followRecord.vue'),
          meta: {title: '跟进记录',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_memorandum',
          name: 'c_memorandum',
          component: () => import('@/view/customer/customerCP/c_memorandum.vue'),
          meta: {title: '备忘录',keepAlive: false},
          hidden:true
        },
        {
          path: 'baseInformation',
          name: 'baseInformation',
          component: () => import('@/view/customer/customerCP/baseInformation.vue'),
          meta: {title: '客户基本信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'companyPersonnel',
          name: 'companyPersonnel',
          component: () => import('@/view/customer/customerCP/companyPersonnel.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'account',
          name: 'account',
          component: () => import('@/view/customer/customerCP/account.vue'),
          meta: {title: '账号管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'points',
          name: 'points',
          component: () => import('@/view/customer/customerCP/points.vue'),
          meta: {title: '积分管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAccount',
          name: 'bankAccount',
          component: () => import('@/view/customer/customerCP/bankAccount.vue'),
          meta: {title: '银行账户',keepAlive: false},
          hidden:true
        },
        {
          path: 'shoppingCart',
          name: 'shoppingCart',
          component: () => import('@/view/customer/customerCP/shoppingCart.vue'),
          meta: {title: '购物车',keepAlive: false},
          hidden:true
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: () => import('@/view/customer/customerCP/favorites.vue'),
          meta: {title: '收藏夹',keepAlive: false},
          hidden:true
        },
        {
          path: 'consumptionAnalysis',
          name: 'consumptionAnalysis',
          component: () => import('@/view/customer/customerCP/consumptionAnalysis.vue'),
          meta: {title: '消费分析统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'behaviorAnalysis',
          name: 'behaviorAnalysis',
          component: () => import('@/view/customer/customerCP/behaviorAnalysis.vue'),
          meta: {title: '行为分析统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'followUpRecord',
          name: 'followUpRecord',
          component: () => import('@/view/customer/customerCP/followUpRecord.vue'),
          meta: {title: '跟进记录',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelDetail',
          name: 'personnelDetail',
          component: () => import('@/view/customer/customerCP/personnelDetail.vue'),
          meta: {title: '公司人员信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelAddEdit',
          name: 'personnelAddEdit',
          component: () => import('@/view/customer/customerCP/personnelAddEdit.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'accountAddEdit',
          name: 'accountAddEdit',
          component: () => import('@/view/customer/customerCP/accountAddEdit.vue'),
          meta: {title: '公司账号',keepAlive: false},
          hidden:true
        },
        {
          path: 'pointsEdit',
          name: 'pointsEdit',
          component: () => import('@/view/customer/customerCP/pointsEdit.vue'),
          meta: {title: '积分订单编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAddEdit',
          name: 'bankAddEdit',
          component: () => import('@/view/customer/customerCP/bankAddEdit.vue'),
          meta: {title: '银行账号编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'orderStatistics',
          name: 'orderStatistics',
          component: () => import('@/view/customer/customerCP/orderStatistics.vue'),
          meta: {title: '订单统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'returnStatistics',
          name: 'returnStatistics',
          component: () => import('@/view/customer/customerCP/returnStatistics.vue'),
          meta: {title: '退货统计',keepAlive: false},
          hidden:true
        },
        {
          path: 'relatedBusiness',
          name: 'relatedBusiness',
          component: () => import('@/view/customer/customerCP/relatedBusiness.vue'),
          meta: {title: '业务关联客户管理',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/product',
    	name: 'product',
      activPath:'product',
      component: admin,
      redirect: '/product/productCP',
      noChildren:false,
      meta: {title: '产品'},
      children:[
        {
          path: 'productCP',
          name: 'productCP',
          component: () => import('@/view/product/productCP/index.vue'),
          meta: {title: '菲尔产品',sideBar:true,keepAlive: true},
        },
        // {
        //   path: 'productHighSeas',
        //   name: 'productHighSeas',
        //   component: () => import('@/view/product/productCP/productHighSeas.vue'),
        //   meta: {title: '产品公海'},
        // },
        {
          path: 'productDetail',
          name: 'productDetail',
          component: () => import('@/view/product/productCP/productDetail.vue'),
          meta: {title: '产品详情',keepAlive: false},
          hidden:true
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/view/product/productCP/feedback.vue'),
          meta: {title: '相关问题',keepAlive: false},
          hidden:true
        },
        {
          path: 'VINDetails',
          name: 'VINDetails',
          component: () => import('@/view/product/productCP/VINDetails.vue'),
          meta: {title: 'VIN结果',keepAlive: false},
          hidden:true
        },
        {
          path: 'salesHistory',
          name: 'salesHistory',
          component: () => import('@/view/product/productCP/salesHistory.vue'),
          meta: {title: '销售历史',keepAlive: false},
          hidden:true
        },
        {
          path: 'productDetailEdit',
          name: 'productDetailEdit',
          component: () => import('@/view/product/productCP/productDetailEdit.vue'),
          meta: {title: '产品信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPic',
          name: 'productPic',
          component: () => import('@/view/product/productCP/productPic.vue'),
          meta: {title: '图片',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPrice',
          name: 'productPrice',
          component: () => import('@/view/product/productCP/productPrice.vue'),
          meta: {title: '价格',keepAlive: false},
          hidden:true
        },
        {
          path: 'productModel',
          name: 'productModel',
          component: () => import('@/view/product/productCP/productModel.vue'),
          meta: {title: '适用车型',keepAlive: false},
          hidden:true
        },
        {
          path: 'productLanguage',
          name: 'productLanguage',
          component: () => import('@/view/product/productCP/productLanguage.vue'),
          meta: {title: '其他语言',keepAlive: false},
          hidden:true
        },
        {
          path: 'productContrast',
          name: 'productContrast',
          component: () => import('@/view/product/productCP/productContrast.vue'),
          meta: {title: '对照号',keepAlive: false},
          hidden:true
        },
        {
          path: 'productShop',
          name: 'productShop',
          component: () => import('@/view/product/productCP/productShop.vue'),
          meta: {title: '电商内容',keepAlive: false},
          hidden:true
        },
        {
          path: 'productRelation',
          name: 'productRelation',
          component: () => import('@/view/product/productCP/productRelation.vue'),
          meta: {title: '关联设置',keepAlive: false},
          hidden:true
        },
        {
          path: 'productknowledge',
          name: 'productknowledge',
          component: () => import('@/view/product/productCP/productknowledge.vue'),
          meta: {title: '知识库',keepAlive: false},
          hidden:true
        },
        {
          path: 'productPrinting',
          name: 'productPrinting',
          component: () => import('@/view/product/productCP/productPrinting.vue'),
          meta: {title: '标签打印',keepAlive: false},
          hidden:true
        },
        {
          path: 'productStore',
          name: 'productStore',
          component: () => import('@/view/product/productCP/productStore.vue'),
          meta: {title: '门店价格维护',keepAlive: false},
          hidden:true
        },
        {
          path: 'productCustomerStock',
          name: 'productCustomerStock',
          component: () => import('@/view/product/productCP/productCustomerStock.vue'),
          meta: {title: '客户库存',keepAlive: false},
          hidden:true
        },
        {
          path: 'productOnHandStock',
          name: 'productOnHandStock',
          component: () => import('@/view/product/productCP/productOnHandStock.vue'),
          meta: {title: '现有库存',keepAlive: false},
          hidden:true
        },
        {
          path: 'productTest',
          name: 'productTest',
          component: () => import('@/view/product/productCP/productTest.vue'),
          meta: {title: '检验项目',keepAlive: false},
          hidden:true
        },
        {
          path: 'productDrawing',
          name: 'productDrawing',
          component: () => import('@/view/product/productCP/productDrawing.vue'),
          meta: {title: '检测图纸',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/select',
    	name: 'select',
      activPath:'select',
      component: admin,
      redirect: '/select/cart',
      noChildren:false,
      meta: {title: '购物车'},
      children:[
        {
          path: 'cart',
          name: 'cart',
          component: () => import('@/view/select/cart/index.vue'),
          meta: {title: '购物车',sideBar:true,keepAlive: true},
        },
      ],
    },
    {
    	path: '/quotedPrice',
    	name: 'quotedPrice',
      activPath:'quotedPrice',
      component: admin,
      redirect: '/quotedPrice/quotedPriceCP',
      noChildren:false,
      meta: {title: '报价'},
      children:[
        {
          path: '/quotedPrice/quotedPriceCP',
          name: 'quotedPriceCP',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/index.vue'),
          meta: {title: '报价',sideBar:true,keepAlive: true},
        },
        {
          path: '/quotedPrice/generateQuotedPriceOrder',
          name: 'generateQuotedPriceOrder',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/generateQuotedPriceOrder.vue'),
          meta: {title: '报价单详情',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/bills',
    	name: 'bills',
      activPath:'bills',
      component: admin,
      noChildren:false,
      redirect: '/bills/billsCP',
      meta: {title: '订单'},
      children:[
        {
          path: 'billsCP',
          name: 'billsCP',
          component: () => import('@/view/bills/billsCP/order.vue'),
          meta: {title: '订单',sideBar:true,keepAlive: true},
        },
        {
          path: 'generateOrderDetail',
          name: 'generateOrderDetail',
          component: () => import('@/view/bills/billsCP/generateOrderDetail.vue'),
          meta: {title: '订单详情',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/pack',
    	name: 'pack',
      activPath:'pack',
      component: admin,
      redirect: '/pack/packCP',
      noChildren:false,
      meta: {title: '打包(发货)'},
      children:[
        {
          path: 'packCP',
          name: 'packCP',
          component: () => import('@/view/pack/packCP/pack.vue'),
          meta: {title: '打包(发货)',sideBar:true,keepAlive: false},
        },
        {
          path: 'g_AddEditPackOrder',
          name: 'g_AddEditPackOrder',
          component: () => import('@/view/pack/packCP/g_AddEditPackOrder.vue'),
          meta: {title: '打包(发货)详情',keepAlive: false},
          hidden:true
        },
        {
          path: 'generatePackOrder',
          name: 'generatePackOrder',
          component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
          meta: {title: '其他打包(发货)',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/packing',
    	name: 'packing',
      activPath:'packing',
      component: admin,
      redirect: '/otherBills/packing',
      noChildren:false,
      meta: {title: '装箱单'},
      children:[
        {
          path: '/otherBills/packing',
          name: 'packing',
          component: () => import('@/view/other/otherBills/billsCP/packing.vue'),
          meta: {title: '装箱单',sideBar:true,keepAlive: true},
        },
      ],
    },
    {
    	path: '/SHistory',
    	name: 'SHistory',
      activPath:'SHistory',
      component: admin,
      redirect: '/SHistory/SHistoryCP',
      noChildren:false,
      meta: {title: '销售历史'},
      children:[
        {
          path: 'SHistoryCP',
          name: 'SHistoryCP',
          component: () => import('@/view/SHistory/SHistoryCP/SHistory.vue'),
          meta: {title: '销售历史',sideBar:true,keepAlive: false},
        },
      ],
    },
    {
    	path: '/other',
    	name: 'other',
      activPath:'other',
      component: admin,
      redirect: '/other/purchaseResponse/purchaseResponseCP',
      noChildren:true,
      meta: {title: '其他'},
      children:[
        {
          path: '/purchaseResponse/purchaseResponseCP',
          name: 'purchaseResponseCP',
          component: () => import('@/view/other/purchaseResponse/purchaseResponseCP/index.vue'),
          meta: {title: '采购',sideBar:true,keepAlive: false},
        },
        {
          path: '/ztStockManage/ztStockManageCP',
          name: 'ztStockManageCP',
          component: () => import('@/view/other/ztStockManage/ztStockManageCP/index.vue'),
          meta: {title: '在途库存管理',sideBar:true,keepAlive: false},
        },
        {
          path: '/statistics/statisticsCP',
          name: 'statisticsCP',
          component: () => import('@/view/other/statistics/statisticsCP/index.vue'),
          meta: {title: '统计',keepAlive: false},
        },
        {
          path: '/quotedPrice/quotedHistory',
          name: 'quotedHistory',
          component: () => import('@/view/other/quotedPrice/quotedPriceCP/quotedHistory.vue'),
          meta: {title: '报价历史',sideBar:true,keepAlive: true},
        },
        {
          path: '/trackingPlan/trackingPlanCP',
          name: 'trackingPlanCP',
          component: () => import('@/view/other/trackingPlan/trackingPlanCP/index.vue'),
          meta: {title: '计划跟踪',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/credit',
          name: 'credit',
          component: () => import('@/view/other/otherBills/billsCP/credit.vue'),
          meta: {title: '借贷项',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/gift',
          name: 'gift',
          component: () => import('@/view/other/otherBills/billsCP/gift.vue'),
          meta: {title: '礼品单',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/returnGoods',
          name: 'returnGoods',
          component: () => import('@/view/other/otherBills/billsCP/returnGoods.vue'),
          meta: {title: '退货单',sideBar:true,keepAlive: true},
        },
        {
          path: '/otherBills/noReturnGoods',
          name: 'noReturnGoods',
          component: () => import('@/view/other/otherBills/billsCP/noReturnGoods.vue'),
          meta: {title: '无实物退货',sideBar:true,keepAlive: true},
          hidden:true
        },
        {
          path: '/otherBills/materialObject',
          name: 'materialObject',
          component: () => import('@/view/other/otherBills/billsCP/materialObject.vue'),
          meta: {title: '生成有实物退货单',keepAlive: false},
          hidden:true
        },
        {
          path: '/otherBills/noMaterialObject',
          name: 'noMaterialObject',
          component: () => import('@/view/other/otherBills/billsCP/noMaterialObject.vue'),
          meta: {title: '生成无实物退货单',keepAlive: false},
          hidden:true
        },
        {
          path: '/otherBills/generateGiftOrder',
          name: 'generateGiftOrder',
          component: () => import('@/view/other/otherBills/billsCP/generateGiftOrder.vue'),
          meta: {title: '礼品单详情',keepAlive: false},
          hidden:true
        },
        {
          path: '/sprinter/sprinterCP',
          name: 'pdDimension',
          component: () => import('@/view/other/sprinter/sprinterCP/pdDimension.vue'),
          meta: {title: '数据分析',sideBar:true,keepAlive: true},
        },
        {
          path: '/salesDemand/salesDemandCP',
          name: 'salesDemand',
          component: () => import('@/view/other/salesDemand/salesDemandCP/index.vue'),
          meta: {title: '销售需求',sideBar:true,keepAlive: true},
        },
        // {
        //   path: '/contract/contractCP',
        //   name: 'contract',
        //   component: () => import('@/view/other/contract/contractCP/index.vue'),
        //   meta: {title: '合同管理',sideBar:true,keepAlive: true},
        // },
        // {
        //   path: '/contract/contractEdit',
        //   name: 'contractEdit',
        //   component: () => import('@/view/other/contract/contractCP/contractEdit.vue'),
        //   meta: {title: '合同页面',keepAlive: true},
        //   hidden:true
        // },
        // {
        //   path: '/contract/contractPreview',
        //   name: 'contractPreview',
        //   component: () => import('@/view/other/contract/contractCP/contractPreview.vue'),
        //   meta: {title: '合同预览',keepAlive: true},
        //   hidden:true
        // },
      ],
    },
  ]


const router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
  routes
})
// 解决 Vue 重复点击相同路由报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js